const trackerFiller = document.querySelector('.tracker_filler');
const trackerBar = document.querySelector('.tracker_bar');
const markers = document.querySelectorAll('.marker');

if (trackerFiller && trackerBar) {
  const subMonths = trackerBar.dataset.submonths;
  const trackerBarWidth = (subMonths / 3) * 100;

  markers[0].querySelector('.markerMsg').innerText = 'Free Bottle';
  markers[1].querySelector('.markerMsg').innerText = 'Free Hat';
  markers[2].querySelector('.markerMsg').innerText = 'Free Bag';
  trackerFiller.style.width = trackerBarWidth + '%';
}
